function getMessage(field, args) {
  if (args === void 0) args = []
  var errMsg = args[0]
  return errMsg
}

function validate(value, args) {
  if (value) {
    if (args === void 0) args = []
    var errMsg = args[0]
    if (errMsg) {
      return false
    } else return true
  } else return true
}

export default {
  getMessage,
  validate
}
